import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const HigienizacaoSanitizacao = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="MEDIDAS DE HIGIENIZAÇÃO E SANITIZAÇÃO" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="Lavabo para Colaboradores e Institucionalizados" nome="colaboradores" modulo={modulo} index={n}
                             widthWeb="23vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Pontos de infiltração(insalubridade)" nome="insalubre" modulo={modulo} index={n}
                             widthWeb="23vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Álcool 70% (gel ou líquido) para Profissionais e Pacientes" nome="alcool" modulo={modulo} index={n}
                             widthWeb="23vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Problemas em Relação ao Abastecimento de Água" nome="abastecimento" modulo={modulo} index={n}
                             widthWeb="23vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Select label="Toalha Descartável para Higienização dos Colaboradores e Institucionalizados" nome="toalha" modulo={modulo} index={n}
                             widthWeb="23vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                    <HeaderVerde texto="LEGALIDADE" />
                    <div style={{ textAlign: "left" }}>
                        <Select label="A Lavanderia Atende as Normas de Segurança - Nota Técnica ANVISA 05/2020" nome="anvisa05" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="23vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                             <Select label="A Cozinha Atende as Normas de Segurança - Nota Técnica ANVISA 05/2020" nome="anvisa052020" modulo={modulo} index={n}
                            componentDisplay="block" widthWeb="23vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                    </div>
                </Caixa>
            )
        }
        return partes
    }
}

export default HigienizacaoSanitizacao